import React from "react";
import styles from "./ResultsSummarySection.css";
import Accordion from "../../../widgets/Accordion/Accordion.js";
import { parse } from "../../../models/parser.js";
import RESULT_TYPES from "../../../models/ResultTypes.js";

const ResultsSummarySection = ({
  getSummaryData,
  headerTitle,
  resultType,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <section id="results-summary" className={styles.resultsSummary}>
        <Accordion
          maxHeight={500}
          expandButtonClassName={styles.customAccordionExpand}
          requireMeasurement
        >
          {headerTitle && (
            <div className={styles.loadingResultsSummarySkeleton}>
              <h2>
                {resultType === RESULT_TYPES.TOPIC
                  ? "Topic:"
                  : "Loading Keyword:"}{" "}
                <span
                  className={`${resultType === RESULT_TYPES.TOPIC ? styles.displayTextTopic : styles.displayTextKeyword}`}
                >
                  {headerTitle}
                </span>{" "}
                (loading ...)
              </h2>
            </div>
          )}
        </Accordion>
      </section>
    );
  }

  return (
    <section id="results-summary" className={styles.resultsSummary}>
      <Accordion
        maxHeight={500}
        expandButtonClassName={styles.customAccordionExpand}
        requireMeasurement
      >
        {headerTitle && (
          <h2>
            {resultType === RESULT_TYPES.TOPIC ? "Topic:" : "Keyword:"}{" "}
            <span
              className={`${resultType === RESULT_TYPES.TOPIC ? styles.displayTextTopic : styles.displayTextKeyword}`}
            >
              {headerTitle}
            </span>{" "}
            (auto-generated)
          </h2>
        )}
        {parse(getSummaryData())}
      </Accordion>
    </section>
  );
};

export default ResultsSummarySection;
